import React from "react";

import {
  loadAdminConfiguration,
  loadBeforeCreateDatasourcesPage,
  loadCreateDatasourcesPage,
  loadCreateWorkspacePage,
  loadDatasourceDetailPage,
  loadDatasourceSelectPage,
  loadDatasourcesPage,
  loadInternalDashboard,
  loadOrgDesignSettingsPage,
  loadWorkspaceConfigurationPage,
  loadWorkspaceSettings,
  loadWorkspacesPage,
} from "./lazyRouteLoaders.js";

const BeforeCreateDatasourcesPage = React.lazy(loadBeforeCreateDatasourcesPage);
const CreateDatasourcesPage = React.lazy(loadCreateDatasourcesPage);
const CreateWorkspacePage = React.lazy(loadCreateWorkspacePage);
const DatasourcesPage = React.lazy(loadDatasourcesPage);
const DatasourceDetailPage = React.lazy(loadDatasourceDetailPage);
const DatasourceSelectPage = React.lazy(loadDatasourceSelectPage);
const WorkspacesPage = React.lazy(loadWorkspacesPage);
const WorkspaceConfigurationPage = React.lazy(loadWorkspaceConfigurationPage);
const InternalDashboard = React.lazy(loadInternalDashboard);
const AdminConfiguration = React.lazy(loadAdminConfiguration);
const WorkspaceSettings = React.lazy(loadWorkspaceSettings);
const OrgDesignSettingsPage = React.lazy(loadOrgDesignSettingsPage);

export {
  InternalDashboard,
  BeforeCreateDatasourcesPage,
  CreateDatasourcesPage,
  DatasourcesPage,
  DatasourceDetailPage,
  DatasourceSelectPage,
  CreateWorkspacePage,
  WorkspacesPage,
  WorkspaceConfigurationPage,
  AdminConfiguration,
  WorkspaceSettings,
  OrgDesignSettingsPage,
};
